import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import axios from 'axios';

import equipmentItems from '../atoms/equipmentItemsAtom';
import AddEquipment from '../modals/AddEquipment';
import { url } from '../utils/config';
import { toast } from 'react-toastify';
import Button from '../reusable_components/Button';
import { btnOne, inputStyle, title } from '../utils/style';


function EquipmentList() {
    const [showAddForm, setShowAddForm] = useState(false);
    const [equipments, setEquipments] = useState({});
    const [items, setItems] = useRecoilState(equipmentItems)
    const [reloadTable, setReloadTable] = useState(false)
    const navigate = useNavigate();


    useEffect(() => { fetchEquipments() }, [reloadTable])



    async function fetchEquipments() {
        try {
            const reqUrl = url + '/special_equipments';
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const { data } = await axios.get(reqUrl, { headers });
            setEquipments(data);
        } catch (error) {
            toast.error(error.response.data.message, { autoClose: 3000 })
        }

    }

    async function fetchEquipmentItems(special_equipment_id) {
        try {
            const reqUrl = url + '/special_equipment_items/' + special_equipment_id;
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const data = await axios.get(reqUrl, { headers });
            console.log(data.data);
            setItems(data.data);
            navigate('items');
        } catch (error) {
            toast.error(error.response.data.message, { autoClose: 3000 })
        }

    }

    // function filterEquipmentList() {
    //     const data = equipments.equipmentsList.filter(eq => eq.specialEquipment_id === equipments.specialEquipments[equipmentIndex]['id']);
    //     setInfo(data);
    //     navigate('/special_equipments/info')
    // }



    return (
        <div>
            <div className={title}>Special Equipment</div>
            {
                showAddForm ? <AddEquipment setShowAddForm={setShowAddForm} equipments={equipments} reload={setReloadTable} /> : null
            }
            <div className=" flex justify-between items-center py-4 pr-16">
                <div className='basis-1/3 justify-left'>
                    <input className={inputStyle} placeholder="Search Equipment" />
                </div>
                <div className='flex justify-end'>
                    <Button className={btnOne} name={'Add Equipment'} clickHandler={() => setShowAddForm(!showAddForm)} />
                </div>
            </div>
            <div className="grid grid-cols-5 gap-5">
                {
                    equipments.specialEquipments &&
                    equipments.specialEquipments.map((equipment, index) => (
                        <div
                            key={index}
                            className="mt-2 border rounded-xl shadow-lg p-4 bg-white flex flex-col items-center transition-transform duration-300 hover:scale-105"
                        >
                            <div className="flex">
                                <img
                                    onClick={() => fetchEquipmentItems(equipment.id)}
                                    src={`${url}/${equipment.imageUrl}`}
                                    alt={equipment.name || ""}
                                    className="cursor-pointer h-40 w-48 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300"
                                />
                            </div>
                            <div className="text-center font-semibold text-gray-700 mt-2">
                                {equipment.name}
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    )

}
export default EquipmentList;